import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { Button } from '../../../../flow/models/flow.model';
import { coReviewViewModel, returnArray } from '../../../../models/comodel/coreviewviewmodel.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { chiefsOrderReviewStatus } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { Group } from '../../../models/group.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';

@Component({
    selector: 'co-return',
    templateUrl: './co-return.component.html',
    styleUrls: ['./co-return.component.scss'],
    standalone: false
})
export class CoReturnComponent implements OnInit {

    @Input() coInstanceId: string;
    @Input() coreReviewModel: coReviewViewModel;
    @Input() userSelectedReturnGroup: Group;
    @Output() setCurrentView = new EventEmitter<string>();
    @Output() setCoreReviewModel = new EventEmitter<coReviewViewModel | null>();
    returnText: string = '';
    sub = new Subscription();
    title: string = '';
    subHeader: SubHeader = new SubHeader({ title: this.title });
    arrayGpName: string[] = [];
    arrayGpId: string[] = [];
   // buttonObj: {name:string, id:string} = { name: '', id: ''};
    buttonArray: returnArray[] = [];
    completedReturnDialog: Dialog = new Dialog("The Chief's Order was successfully returned to the appropriate group.", [new DialogButton("OK", true, () => this.onReturnDialogConfirm())]);

    constructor(
        private activeRoute: ActivatedRoute,
        private chiefsOrderService: ChiefsOrderService,
        private readonly loader: LoaderService,
        private router: Router,
        public dialogService: DynamicDialogService,
        private subHeaderService: SubHeaderService
    ) { }

    ngOnInit() {

        //If the current level doesn't support assigning to a specific group, an no return group is specified
        if (!this.coreReviewModel.currentLevel.canSelectAssignToGroup && this.coreReviewModel.currentLevel.returnToGroup != ""
            && this.coreReviewModel.currentLevel.returnToGroup != null) {

            this.arrayGpName = this.coreReviewModel.currentLevel.returnToGroup.split(',');
            this.arrayGpId = this.coreReviewModel.currentLevel.returnToGroupId.split(',');
        }
        else {
            this.arrayGpName.push(this.userSelectedReturnGroup.displayName);
            this.arrayGpId.push(this.userSelectedReturnGroup.id);
        }

        for (let i = 0; i < this.arrayGpId.length; i++) {
            var arr: returnArray = { name: '', id: '' };
            arr.name = this.arrayGpName[i];
            arr.id = this.arrayGpId[i];
            this.buttonArray.push(arr);
        }
        this.title = this.coreReviewModel.templateId;
    }

    ngOnDestroy(): void {
        if (this.sub)
            this.sub.unsubscribe();
    }

    goToReview(): void {
        this.setCurrentView.emit('review-chiefsorder');
    }

    returnCO(event: Event): void {
        this.loader.toggleLoader(true);
        if (this.coreReviewModel.currentLevel.canSelectAssignToGroup) {
            this.coreReviewModel.userSelectedGroup = this.userSelectedReturnGroup;
            this.coreReviewModel.returnToGpId = this.userSelectedReturnGroup.id;
        }
        else {
            let elementId: string = (event.target as Element).id;
            this.coreReviewModel.returnToGpId = elementId;
        }

        this.coreReviewModel.currentReview.reviewStatus = chiefsOrderReviewStatus.Returned;

        var srv$ = this.chiefsOrderService.returnco(this.coreReviewModel).pipe(finalize(() => {
            this.sub.add(srv$);
        })).subscribe(result => {
            if (result) {
                var msg = this.coreReviewModel.templateName;
                this.setCoreReviewModel.emit(null);
                this.loader.toggleLoader(false);

                this.completedReturnDialog.toggleDialog(true);
                this.dialogService.updateDialog(this.completedReturnDialog);
            }
        }, error => {
            this.loader.toggleLoader(false);
            console.log('failed to return...' + error);
        });
    }

    public onReturnDialogConfirm() {
        this.completedReturnDialog.toggleDialog(false);
        this.dialogService.updateDialog(this.completedReturnDialog);
        this.router.navigate(['/home']);
    }
}
